import { destroy, get, patch, post, put } from './index';
import qs from 'qs';

export const saveTrip = (trip) => {
  return post(`/trip/save`, trip);
};

export const saveTripTemplate = ({ tripId, body }) => {
  return post(`/trip/${tripId}/template`, body);
};

export const updateTripDmcReference = ({ tripId, dmcReference }) => {
  return put(`/trip/${tripId}/dmc-reference`, { dmcReference });
};

export const updateTripTemplate = ({ templateId, body }) => {
  return put(`/trip-templates/${templateId}`, body);
};

export const getTripPrograms = ({ filters, locale }) => {
  return post(`/trip/programs?locale=${locale ?? 'en'}`, filters);
};

export const saveTripDays = ({
  tripId,
  tripDays,
  draftPrice,
  folderId,
  travelers,
  globalOptions,
}) => {
  return put(`/trip/${tripId}/days`, {
    tripDays,
    draftPrice,
    folderId,
    travelers,
    globalOptions,
  });
};

export const getTripAccommodationLabels = ({ tripId, locale }) => {
  return get(`/trip/${tripId}/accommodation-labels?locale=${locale ?? 'en'}`);
};

export const getTrip = ({ tripId, versionId }) => {
  return get(`/trip/${tripId}${versionId ? `?version=${versionId}` : ''}`);
};

export const getTripTemplates = ({ filters }) => {
  return get(`/trip-templates?${qs.stringify(filters)}`);
};

export const getTripTemplate = ({ templateId }) => {
  if (!templateId) {
    return Promise.resolve(null);
  }
  return get(`/trip-templates/${templateId}`);
};

export const getTrips = ({ kind, filters }) =>
  post(`/trip?kind=${kind}`, filters);

export const getOneTrip = ({ tripId }) => get(`/trip/${tripId}`);

export const addTripAssistant = ({ tripId, body }) =>
  post(`/trip/${tripId}/tripAssistant`, body);

export const updateBookedTrip = ({ tripId, body }) =>
  patch(`/trip/updateTripBook/${tripId}`, body);

export const saveTripProposal = ({ tripId, body }) => {
  return post(`/trip/${tripId}/proposal`, body);
};

export const getTripHistories = ({ tripId }) => {
  return get(`trip/${tripId}/histories`);
};

export const adjustTrip = ({ tripId, adjustTrip }) => {
  return post(`trip/${tripId}/adjustment`, adjustTrip);
};

export const getTripAdjustments = ({ tripId }) => {
  return get(`trip/${tripId}/adjustments`);
};

export const updateTripAdjustment = ({ tripId, adjustmentId, body }) => {
  return patch(`trip/${tripId}/adjustments/${adjustmentId}`, body);
};

export const deleteTripAdjustment = ({ tripId, adjustmentId }) => {
  return destroy(`trip/${tripId}/adjustments/${adjustmentId}`);
};

export const getTripBookings = ({ tripId, skip = false }) => {
  if (skip) {
    return Promise.resolve([]);
  }
  return get(`trip/${tripId}/bookings`);
};
